import {mutationTypes} from '@/core/constants'
import {PageUtils} from '@/core/utils'
import router from '@/views/routers'

export default class Alert {

    constructor(store) {
        this.store = store
    }

    showError(key) {
        if (!key) {
            key = 'Não foi possível realizar a operação!'
        }
        this.store.commit(mutationTypes.LOKI.SHOW_ALERT, {message: key, type: 'error'})
    }

    showInfo(key) {
        if (!key) {
            key = 'Operação realizada com sucesso!'
        }
        this.store.commit(mutationTypes.LOKI.SHOW_ALERT, {message: key, type: 'success'})
    }
    
    mensagemErroComRedirectTimeout(mensagem, tempoEsperaRedirect = 0){
        const pageUtils = new PageUtils(router)
        const mensagemAguarde = mensagem + ' Aguarde, você será redirecionado'
        if(tempoEsperaRedirect > 0){
            this.showError(mensagemAguarde + ` em ${tempoEsperaRedirect}...`)
        }
        
        setTimeout(() => {
            pageUtils.goToHome()
        }, tempoEsperaRedirect * 1000)
        
        let timeleft = tempoEsperaRedirect-1
        let redirectTimer = setInterval(() => {
            if(timeleft >= 1){
                this.showError(mensagemAguarde + ` em ${timeleft}...`)
            }else{
                this.showError(mensagem + ' Você foi redirecionado.')
                clearInterval(redirectTimer)
            }
            timeleft -= 1
        }, 1000)
    }

}